$(function() {
    $('*[data-action="open-register-modal"]').on('click', function(){
        Manogi.openRegisterModal();
    });

    $('*[data-action="open-account-modal"]').on('click', function(){
        Manogi.openAccountModal($(this).data('token'));
    });

    $('.js-newsletter-button').on('click', function(){
        Manogi.validateNewsletterForm();
    });
});
